import { render, staticRenderFns } from "./tradeOpen.vue?vue&type=template&id=69670b98&scoped=true&"
import script from "./tradeOpen.vue?vue&type=script&lang=js&"
export * from "./tradeOpen.vue?vue&type=script&lang=js&"
import style0 from "./tradeOpen.vue?vue&type=style&index=0&id=69670b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69670b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
